import { render, staticRenderFns } from "./MemoTable.vue?vue&type=template&id=06702223"
import script from "./MemoTable.vue?vue&type=script&lang=js"
export * from "./MemoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports